import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

export function useCapabilities() {
  const query = useQuery({
    queryKey: ["capabilities"],
    queryFn: api.capabilities,
    staleTime: Number.POSITIVE_INFINITY,
    retry: false,
  });
  return {
    fubeiEnabled: query.data?.payments.fubei ?? false,
    paymentMode: query.data?.payments.mode ?? "wap",
    testMode: query.data?.payments.testMode ?? false,
    isLoading: query.isLoading,
  };
}
